import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import api from "../lib/api";
import ProductCard from "./ProductCard";

export default function ProductSection() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/products")
      .then((r) => setProducts(r.data))
      .finally(() => setLoading(false));
  }, []);

  return (
    <section id="compounds" className="relative py-24 md:py-32 max-w-7xl mx-auto px-6 md:px-10">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-14">
        <div>
          <motion.p
            initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
            className="text-[11px] tracking-[0.4em] uppercase text-[#00F0FF] mb-4 font-mono2"
          >
            // The Catalog
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
            className="font-display font-black text-3xl md:text-5xl uppercase tracking-tighter"
          >
            Select Your<br /><span className="text-[#00F0FF] neon-text">Compound</span>
          </motion.h2>
        </div>
        <p className="text-xs text-slate-500 font-mono2 max-w-xs">Research use only. Not for human consumption. Best use &amp; dosing shown per vial.</p>
      </div>

      {loading ? (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {[...Array(6)].map((_, i) => (
            <div key={i} className="border border-white/10 aspect-[3/4] animate-pulse bg-white/[0.02]" />
          ))}
        </div>
      ) : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="product-grid">
          {products.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
        </div>
      )}
    </section>
  );
}
